"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 38.4 24",
    width: "38.4",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.84 9.52a.94.94 0 0 0 .36.08.81.81 0 0 0 .72-.44l2.17-4.36h1.91a.8.8 0 0 0 0-1.6h-2.4a.82.82 0 0 0 -.72.44l-2.4 4.8a.82.82 0 0 0 .36 1.08z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m37.6 11.2h-21.6v-10.4a.8.8 0 0 0 -.8-.8h-7.2a.81.81 0 0 0 -.7.41l-3.95 7.1-3.12 3.12a.81.81 0 0 0 -.23.57v8.8a.8.8 0 0 0 .8.8h3.28a4 4 0 0 0 7.84 0h14.56a4 4 0 0 0 7.84 0h3.28a.8.8 0 0 0 .8-.8v-8a.8.8 0 0 0 -.8-.8zm-.8 1.6v3.2h-20.8v-3.2zm-10.32 6.4h-14.56a4 4 0 0 0 -.74-1.6h16a4 4 0 0 0 -.7 1.6zm-21.91-10.63.13-.18 3.77-6.79h5.93v14.4h-12.8v-4.47zm-3 9h3.25a4 4 0 0 0 -.74 1.6h-2.48zm6.43 4.83a2.4 2.4 0 1 1 2.4-2.4 2.41 2.41 0 0 1 -2.4 2.4zm22.4 0a2.4 2.4 0 1 1 2.4-2.4 2.41 2.41 0 0 1 -2.4 2.4zm6.4-3.2h-2.48a4 4 0 0 0 -.74-1.6h3.22z"
  })));
};

exports["default"] = _default;